<template>
  <div>
    <div class="jiudu-record-comp" v-for="(item, index) in list" :key="index">
      <div class="card" :class="{'is-stop': item.status === 0}">
        <div class="card-t">
          <div class="flex-between">
            <span class="card-t-cname">{{item.curriculumName}}
            </span>
            <!-- v-if="moreOperationActions.length" -->
            <span class="card-t-name" 
              v-if="
                app.permission.op('deactivate_course_fee') || 
                (item.classStudentList && item.classStudentList.length>0)"
              @click="showOperation(item)">
              <van-icon name="ellipsis" size="18" />
            </span>
          </div>
          <div class="card-t-campus">{{item.campusName}}</div>
        </div>
        <div class="card-b">
          <div class="card-b-class">
            <div class="class-title van-hairline--bottom">排课点名</div>
            <div class="class-attend">
              <div class="total">
                <span class="item">已排<span class="num">{{item.courseArrangeAmount}}</span>节课</span>
                <span class="">已点名<span class="num">{{item.alreadyAttendedAmount}}</span>节课</span>
              </div>
              <div class="record">
                出勤<span class="num">{{item.attendanceCount}}</span>
                迟到<span class="num">{{item.lateCount}}</span>
                请假<span class="num">{{item.askForLeaveCount}}</span>
                未到<span class="num">{{item.absentAmount}}</span>
              </div>
            </div>
          </div>
          <div class="card-b-class" v-if="getInClassList(item).length>0">
            <div class="class-title van-hairline--bottom">在读班级</div>
            <div class="class-item flex-between" v-for="(it,idx) in getInClassList(item)" :key="idx">
              <router-link tag="span" class="cname van-ellipsis" :to="`/baseClassDetail/${it.classId}`">{{it.className}} ></router-link>
              <!-- <span class="cname van-ellipsis">{{it.className}}</span> -->
              <!-- <router-link 
                class="cdate" 
                :to="`/inOutClassLog?sid=${it.studentId}&cid=${it.classId}&sName=${studentName}&cName=${it.className}&courseStatus=${item.courseStatus}`">
                出入班记录
              </router-link> -->
            </div>
          </div>
          <div class="card-b-class" v-if="getOutClassList(item).length>0">
            <div class="class-title pre van-hairline--bottom">曾就读班级</div>
            <div class="class-item flex-between" v-for="(it,idx) in getOutClassList(item)" :key="idx">
              <router-link tag="span" class="cname van-ellipsis" :to="`/baseClassDetail/${it.classId}`">{{it.className}} ></router-link>
              <!-- <span class="cname van-ellipsis">{{it.className}}</span> -->
              <!-- <router-link 
                class="cdate" 
                :to="`/inOutClassLog?sid=${it.studentId}&cid=${it.classId}&sName=${studentName}&cName=${it.className}&courseStatus=${item.courseStatus}`">
                出入班记录
              </router-link> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-empty
      image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
      description="暂无就读记录"
      v-if="!list||(list&&list.length==0)"
      image-size="128">
    </van-empty>
    <!-- 更多操作列表 -->
    <van-action-sheet
      v-model="showMoreOperation"
      :actions="moreOperationActions"
      cancel-text="取消"
      close-on-click-action
      get-container="body"
      @cancel="showMoreOperation = false"
      @select="onSelectOperation"
    />
    <van-popup 
      class="show-inOutClass-popup"
      v-model="showInOutPopup" 
      position="bottom" 
      closeable
      :style="{ height: '372px' }"
      get-container="body"
      :safe-area-inset-bottom="true">
      <div class="title">{{currentOp.curriculumName}}</div>
      <div class="body">
        <div class="curriculum-log-comp van-hairline--bottom" v-for="(item,index) in inOutClassRecordList" :key="index">
          <div class="type">{{recordTypes[item.type]}}</div>
          <div class="log-time">{{item.date | formatDatetime("yyyy-MM-dd")}}</div>
          <div class="log-details">{{getLogDetails(item)}}</div>
          <div class="log-operator">操作人：{{item.operatorName|| '-'}}</div>
          <template v-if="item.type==9">
            <div class="log-details">有效期变更至：{{item.expireTimeStr}}</div>
            <div class="log-details">订单编号：{{item.orderNo}}</div>
            <div class="log-details" v-if="item.remark">备注：{{item.remark}}</div>
          </template>
        </div>
      </div>
    </van-popup>
    <van-dialog 
      getContainer="body"
      v-model="markQuitClass" 
      title="标记为“不再上课”" 
      class="card-mark-quit-dialog"
      @confirm="markQuitClassConfirm"
      confirm-button-text="确定"
      show-cancel-button>
      <div class="card-mark-quit-dialog-contain">
        <div style="text-align: center; margin-bottom: calc(var(--gap) * 12);">
          标记为不再上课后，学员会自动移出课程所在班级，并移出“上课时间”为今天及之后的该课程下的未点名排课。请确认是否将“{{currentOp.curriculumName}}”标记为不再上课？
        </div>
         <div class="tips-contain" v-if="currentOp.cardNameList && currentOp.cardNameList.length">
        
          <p>有{{currentOp.cardNameList.length}}张关联的如下课程上课卡，将自动标记为“不再费用预警”（课时包上课卡不会自动标记）</p>          
            
          <p class="class-name" v-for="item in currentOp.cardNameList" :key="item">
            <template v-if="currentOp.cardType == 1">
              <span class="tag card">课时包</span>{{item}}
            </template>
            <template v-else>
              <span class="tag">课程</span>
              <span class="charge-type-tag" v-if="currentOp.chargeType === 2">天</span>
              {{item}}
            </template>
          </p> 
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'jiudu-record-comp',
  props: {
    studentId: {
      type: [Number, String],
    },
    studentName: {
      type: String,
    },
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      showMoreOperation: false,
      currentOp: {},
      moreOperationActions: [],
      inOutClassRecordList: [],
      recordTypes: ['', '入班','购买','转班','退费','出班','转出','费用结转','课时过期','变更有效期', '结课', '撤销结课'],
      showInOutPopup: false,
      markQuitClass: false,
      classData: {},
    }
  },
  methods: {
    showOperation(item) {
      this.currentOp = item;
      let actions = [];
      if (app.permission.op('add_class_student')) {
        actions.push({ name: "加入班级", id: 4});
      }
      if (app.permission.op('transfer_class_student') && this.getInClassList(item).length>0) {  
        actions.push({ name: "调班", id: 5});
      }
      

      if (app.permission.op('deactivate_course_fee')) {
        if (item.status == 1) {
          actions.push({ name: "标记为“不再上课”", id: 2 , subname: '出班，并移出“未点名”排课'}); 
        } else {
          actions.push({ name: "取消“不再上课”标记", id: 3 }); 
        }
      }
      if (item.classStudentList && item.classStudentList.length > 0) {
        actions.push({ name: "出入班记录", id: 1 }); 
      }

      this.moreOperationActions = actions;
      this.showMoreOperation = true;
    },
    // 执行操作
    onSelectOperation(val) {
      switch (val.id) {
        case 1:
          this.showInOutRecord();
          break;
        case 2:
          this.markQuitClass = true;
          break;
        case 3:
          this.updateCourseStudent(1);
          break;
        case 4:
          this.addToClass();
          break;
        case 5:
          this.transferClass();
          break;
        default:
          break;
      }
    },
    // 加入班级
    addToClass() {
      const {campusId, campusName, curriculumId, curriculumName,  } = this.currentOp;
      this.$router.push(
        `/add-to-class?campusId=${campusId}&campusName=${campusName}&studentId=${this.studentId}&studentName=${this.studentName}&curriculumId=${curriculumId}&curriculumName=${curriculumName}`
      );
    },

    // 调班
    transferClass() {
      const {campusId, campusName, curriculumId, classStudentList } = this.currentOp;
      const curClass = classStudentList.find(item=>item.isInClass == 1);
      
      this.$router.push(
        `/tb?campusId=${campusId}&campusName=${campusName}&studentId=${this.studentId}&studentName=${this.studentName}&curriculumId=${curriculumId}&classId=${curClass.classId}&className=${curClass.className}`
      );
    },
    showInOutRecord() { //展示操作记录
      this.showLoading();
      this.$api.findOperationRecordList({
        curriculumId: this.currentOp.curriculumId,
        priceItemId: this.currentOp.priceItemId,
        studentId: this.studentId,
        campusId: this.currentOp.campusId,
      }).then(res=>{
        this.$toast.clear();
        this.showInOutPopup = true;
        if (res.code == 200) {
          this.inOutClassRecordList = res.data;
        } else {
          this.$toast.fail(res.msg);
        }
      })
    },
    getInClassList(item) {
      let classStudentList = item.classStudentList ? item.classStudentList : [];
      return classStudentList.filter(v=>v.isInClass==1);
    },
    getOutClassList(item) {
      let classStudentList = item.classStudentList ? item.classStudentList : [];
      return classStudentList.filter(v=>v.isInClass==0);
    },
    getLogDetails (log) { //commodityType==1班级，2课程
      switch (log.type) {
        case 1:
          return `加入${log.className}`;
        case 2:
          return `购买${log.commodityType==1?log.className:log.curriculumName}(共${log.arrangeCount}${log.priceUnitName || '课时'})`;
        case 3:
          return log.turnClassDesc;
        case 4:
          return `退费${log.arrangeCount}${log.priceUnitName  || '课时'}`;
        case 5:
          return `从${log.className}出班`;
        case 6:
          return `由课程转出${log.arrangeCount}${log.priceUnitName  || '课时'}`;
        case 7:
          return `结转${log.arrangeCount}${log.priceUnitName  || '课时'}费用到电子钱包`;
        case 8:
          return `订单${log.orderNo}有 ${log.expireAmount} ${log.priceUnitName  || '课时'}已于 ${log.expireTimeStr} 过期`;
        case 9:
          return `操作人：${log.teacherName}`;
        case 10:
          return `操作人：${log.teacherName}`;
        case 11:
          return `操作人：${log.teacherName}`;
        default: 
          return '其它'
      }
    },
    updateCourseStudent(status) {
      let { studentId, currentOp } = this;
      let params = {
        studentId,
        campusId: this.currentOp.campusId,
        curriculumId: currentOp.curriculumId,
        priceItemId: currentOp.priceItemId,
      }
      this.showLoading();
      this.$api.courseStudentEditBatch({
        courseStudentRelationList: [params],
        // status: currentOp.status,
        // status: (currentOp.status+1)%2,
        status: status,
      })
      .then((res)=>{
        if (res.code === 200){
          this.$toast.success('操作成功');
          app.vue.$emit('refresh-student-school-record-list');
        }
        if (res.code > 60000) {
          app.http.tipErr(res.msg || '网络异常，请稍后重试');
        }
      })
    },
    markQuitClassConfirm(){
      this.updateCourseStudent(0)
    }
  }
}
</script>

<style lang="scss" scoped>
.jiudu-record-comp {
  .card {
    position: relative;
    margin: 0 calc(var(--gap) * 16) calc(var(--gap) * 12) calc(var(--gap) * 16);
    background-color: var(--white);
    border-radius: var(--radius-base);
    &.is-stop::before {
      position: absolute;
      top:0;
      right: calc(var(--gap) * 22);
      content: "";
      width: calc(var(--w) * 82);
      height: calc(var(--w) * 82);
      background: transparent url('https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0094.png') top right/cover no-repeat;
      z-index: 0;

    }
    .card-t {
      position: relative;
      padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
      background: rgba(255, 255, 255, 0.3);
      .card-t-cname {
        font-size:var(--fs-lg);
        line-height:var(--lh-lg);
        color: var(--g8);
        flex: 1;
        font-weight: var(--bold);
      }
      .card-t-name {
        margin-left: calc(var(--gap) * 4);
        flex-shrink: 0;
        color: var(--g6);
        z-index: 11;
      }
      .card-t-campus {
        color: var(--g6);
      }
    }
    .card-b {
      position: relative;
      .card-b-class {
        margin: 0 calc(var(--gap) * 16);
        padding-bottom: calc(var(--gap) * 12);
        .class-title {
          position: relative;
          padding: calc(var(--gap) * 8) 0 calc(var(--gap) * 8) calc(var(--gap) * 8);
          color: var(--g8);
          font-size:var(--fs-sm);
          line-height:var(--lh-sm);
          &.pre {
            &::before {
              background-color: var(--g5);
            }
          }
          &::before {
            content: "";
            position: absolute;
            top: calc(var(--w) * 10);
            left: 0;
            width: calc(var(--w) * 3);
            height: calc(var(--w) * 12);
            border-radius: calc(var(--w) * 2);
            background-color: var(--c2);
          }
        }
        .class-attend {
          .total {
            margin: calc(var(--gap) * 8) 0;
            .item {
              margin-right: calc(var(--gap) * 16);
            }
            .num {
              font-size:var(--fs-lg);
              line-height:var(--lh-lg);
              padding: 0 calc(var(--gap) * 4);
              font-weight: var(--bold);
            }
          }
          .record {
            padding: calc(var(--gap) * 8) 0;
            text-align: center;
            background-color: var(--g1);
            border-radius: var(--radius-base);
            .num {
              padding: 0 calc(var(--gap) * 8) 0 calc(var(--gap) * 2);
              font-weight: var(--bold);
            }
          }
        }
        .class-item {
          padding-top: calc(var(--gap) * 12);
          font-size:var(--fs-md);
          line-height:var(--lh-md);
          color: var(--g6);
          .cdate {
            font-size:var(--fs-sm);
            line-height:var(--lh-sm);
            color: var(--tlc);
          }
          .cname {
            color: var(--tlc);
          }
        }
      }
    }
    .buzaiicon {
      font-size: 60px;
      color: var(--g5);
      position: absolute;
      right: 32px;
      top: 10px;
      transform:rotate(30deg);
    }
  }
}
.show-inOutClass-popup {
  display: flex;
  flex-direction: column;
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  color: var(--g8);
  .title{
    padding: calc(var(--gap) * 16) calc(var(--gap) * 35) calc(var(--gap) * 12) calc(var(--gap) * 16);
    margin-bottom: calc(var(--gap) * 8);
    height: calc(var(--w) * 48);
    font-size:var(--fs-lg);
    font-weight: 500;
    text-align: center;
  }
  .curriculum-log-comp {
    position: relative;
    padding: calc(var(--gap) * 8) 0;
    margin: 0 calc(var(--gap) * 16);
    background-color: var(--white);
    border-radius: var(--radius-base);
    color: var(--g6);
    .type {
      font-size:var(--fs-md);
      line-height:var(--lh-md);
      color: var(--g7);
      font-weight: bold;
    }
    .log-time {
      position: absolute;
      right: calc(var(--w) * 12);
      top: calc(var(--w) * 10);
      font-size: var(--fs-sm);
      color: var(--g5);
    }
    .log-operator{
      position: absolute;
      right: calc(var(--w) * 12);
      font-size: var(--fs-sm);
      color: var(--g5);
      bottom: calc(var(--w) * 10);
    }
    .log-details {
      margin-top: calc(var(--gap) * 4);
      font-size:var(--fs-md);
      line-height:var(--lh-md);
    }
  }
}
</style>
<style lang="scss">
.card-mark-quit-dialog-contain{
  margin: calc(var(--gap) * 10) calc(var(--gap) * 24) 0;
  color: var(--g6);
  font-size:var(--fs-md);
  line-height:var(--lh-md);
  .tips-contain{
    max-height: calc(var(--w) * 300);
    padding: calc(var(--gap) * 16);
    margin: calc(var(--gap) * 10) 0 calc(var(--gap) * 24);
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
    background: var(--g1);
    border-radius: var(--radius-base);
    overflow-y: auto;
    .desc {
      color: var(--c3);
    }
    li,p{
      margin: calc(var(--gap) * 8) 0;
    }
    p:first-child{
      margin-top: 0;
    }
    li:last-child{
      margin-bottom: 0;
    }
    p.class-name{
      position: relative;
      font-size:var(--fs-md);
      line-height:var(--lh-md);
      color: var(--g8);
      span.charge-type-tag {
        display: inline-block;
        margin-right: calc(var(--gap) * 4);
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
        padding: calc(var(--gap) * 1) calc(var(--gap) * 4);
        border-radius: 2px;
        white-space: nowrap;                  
        background: rgba(var(--c4-rgb), 0.15);
      }
      .tag {
        margin-right: calc(var(--gap) * 4);
        display: inline-block;
        font-weight: normal;
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
        padding: 0 calc(var(--gap) * 4);
        color: var(--white);
        background: var(--c1);
        border-radius: 2px;
        &.card {
          background-color: var(--c4);
        }
      }
    }
  }
  .tips-contain>ol{
    padding-inline-start: calc(var(--gap) * 16);
    list-style: decimal;
    >li{
      padding-left: calc(var(--gap) * 6);
    }
  }
}
</style>